<bbit-month-navigator
  [date]="$any(date | async)"
  (dateChange)="setDate($any($event))"
></bbit-month-navigator>
